import { AppNS } from 'app';

import { parseReportInspections } from '../common-parsers/common-parsers';

export const parseReport = (reportData: AppNS.Params): AppNS.JobEventReport => {
  return {
    ...reportData,
    eventInspections: parseReportInspections(reportData.eventInspections),
  } as AppNS.JobEventReport;
};

export const parseInspectionsForReport = (
  data: Array<AppNS.Inspection>
): {
  [key: string]: { state: AppNS.InspectionStatus; notes?: string };
} => {
  const output = {} as {
    [key: string]: { state: AppNS.InspectionStatus; notes?: string };
  };
  data.forEach((inspection: AppNS.Inspection) => {
    output[inspection.id] = {
      state: inspection.status,
      ...(inspection.status === 'partially_approved' &&
        inspection.notes && {
          notes: inspection.notes,
        }),
    };
  });

  return output;
};
